export function sortRatingScales(scales) {
  // map for efficient lookup
  const ordering = {
    Overall: 0,
    Cosmetic: 1,
    Performance: 2,
    Glass: 3,
    'Shutter Count': 4,
    'Hours Logged': 5
  }

  return [...scales].sort((a, b) => {
    return ordering[a.name] - ordering[b.name]
  })
}
